/* eslint no-console: 0 */
// Run this example by adding <%= javascript_pack_tag 'hello_vue' %> (and
// <%= stylesheet_pack_tag 'hello_vue' %> if you have styles in your component)
// to the head of your layout file,
// like app/views/layouts/application.html.erb.
// All it does is render <div>Hello Vue</div> at the bottom of the page.

import { createApp, h } from 'vue'
import { createBootstrap } from 'bootstrap-vue-next'
import axios from 'axios'
import App from './components/App.vue';
import Notifications, { notify } from '@kyvg/vue3-notification';
import RegistrationForm from './components/RegistrationForm.vue';
import ZeroReportProfiles from './components/ZeroReportProfiles.vue';
import Impersonates from "./components/Impersonates.vue";
import DispenserGuidesTabs from "./components/DispenserGuidesTabs.vue";
import ClinicalFormulationDrugExemptions from "./components/ClinicalFormulationDrugExemptions.vue";

const app = createApp(App);

app.use(Notifications)
app.use(createBootstrap())

document.addEventListener('DOMContentLoaded', () => {
  let token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

  axios.defaults.headers.common['X-CSRF-Token'] = token
  axios.defaults.headers.common['Accept'] = 'application/json'

  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (error.response && error.response.status == 401) {
      window.location.replace('/users/sign_in');
    } else {
      return Promise.reject(error);
    }
  });

  app.mount('#app');

  const zeroReportProfiles = document.getElementById("zero-report-profiles");
  if (zeroReportProfiles != null) {
    const props = JSON.parse(zeroReportProfiles.dataset.props);
    const zrApp = createApp({
      render: () => h(ZeroReportProfiles, { ...props })
    })
    
    zrApp.use(createBootstrap())
    zrApp.mount(zeroReportProfiles);
  }

  const registrationForm = document.getElementById("registration-form");
  if (registrationForm != null) {
    const registrationApp = createApp({
      components: {
        'registration-form': RegistrationForm
      }
    })

    registrationApp.use(createBootstrap())
    registrationApp.mount(registrationForm);
  }

  const impersonates = document.getElementById("impersonates");
  if (impersonates != null) {
    const impersonatesApp = createApp({
      components: {
        'impersonates-fields': Impersonates
      }
    })

    impersonatesApp.use(createBootstrap())
    impersonatesApp.mount(impersonates);
  }

  const dispenserGuides = document.getElementById("dispenser-guides");
  if (dispenserGuides != null) {
    const dispenserGuidesApp = createApp({
      components: {
        'dispenser-guides-tabs': DispenserGuidesTabs
      }
    })

    dispenserGuidesApp.use(createBootstrap())
    dispenserGuidesApp.mount(dispenserGuides);
  }

  const mountExemptions = function() {
    const element = document.getElementById("clinical-formulation-drug-exemptions");
    if (element != null) {
      const pmpId = parseInt(element.dataset.pmpId);
      const canEdit = element.dataset.canEdit === 'true';
      const exemptionsEnabled = element.dataset.exemptionsEnabled === 'true';
      const exemptionsApp = createApp({
        render: () => h(ClinicalFormulationDrugExemptions, { pmpId, canEdit, exemptionsEnabled })
      });

      exemptionsApp.use(createBootstrap());
      exemptionsApp.mount(element);
    }
  };

  $(document).on('miscellaneous-ready', function() {
    mountExemptions();
  });

  $.get("/alerts", null, null, 'json')
    .done(function (alerts) {
      $.each(alerts, function( index, alert ) {
        notify({
          group: 'app',
          title: alert.subject,
          text: alert.description,
          type: alert.status_type
        });
      });
    });
})
